export default __webpack_public_path__ + "static/media/photo_placeholder.07873d84.svg";